export default import.meta.ROLLDOWN_FILE_URL_nUgjWAfQvFuVv2UKhecz1g